import { useState } from 'react';
import cn from 'classnames';

import { ranges } from './postcodes';

import './PostcodesForm.css';

const PostcodesForm = (props) => {
  const { onSetPostcode } = props;
  const [ inputValue, setInputValue ] = useState('');
  const [ status, setStatus ] = useState(null);

  const getMsg = () => {
    return {
      good: 'Congrats! You are in the service area',
      bad: 'Sorry, same day delivery is not available in your area yet. You can still book your ítem and it will be delivered for your booking dates.'
    }
  }

  const handleSubmit = (value) => {
    const inFirstRange = value >= ranges[1][0] && value <= ranges[1][1];
    const inSecondRange = value >= ranges[2][0] && value <= ranges[2][1];

    let status = '';
    if(!isNaN(Number(value)) && (inFirstRange || inSecondRange)) {
      status = 'good';
      onSetPostcode(value)
    } else {
      status = 'bad';
    }
    setStatus(status);
  }

  const handleChange = (e) => {
    const { value } = e.currentTarget;
    status !== null && setStatus(null)
    if(value.length > 4) {
      return
    }

    setInputValue(value);
    if(value.length === 4) {
      handleSubmit(value)
      return
    }
  }

  const handleBlur = () => {
    setStatus(null)
  }

  const formClasses = cn('rntr-postcodes', {
    'rntr-postcodes_good': status === 'good',
    'rntr-postcodes_bad': status === 'bad'
  })

  return (
    <div className={ formClasses } >
      <input
        className='rntr-postcodes__input'
        type="text"
        placeholder='Only Sydney Metro postcode'
        onChange={ handleChange }
        value={ inputValue }
        onBlur={ handleBlur }/>
        {
          status && 
          <span className='rntr-postcodes__msg'>
            { getMsg()[status] }
          </span>
        }
    </div>
  );
}

export default PostcodesForm;